import { safeString } from '@utils/stringUtil';
import { OfflineOrderingState } from '../types';

const returnOrderItem = (state: OfflineOrderingState, id: string): OfflineOrderingState => {
  const menuItem = state?.order?.orderItems?.find((x) => x.id === id);
  if (menuItem) {
    return {
      ...state,
      menus: [
        ...state.menus,
        {
          count: menuItem?.count,
          discount: menuItem?.discount || 0,
          menuItemId: menuItem?.menuItemId || '',
          title: menuItem?.title || '',
          price: menuItem?.price || 0,
          packagingCost: menuItem?.packagingCost || 0,
          servePackagingCost: menuItem?.packagingCost || 0,
          tempId: safeString(menuItem?.id),
          orderItemToppings: menuItem?.toppings?.map((x) => ({
            count: menuItem?.count,
            price: x.price,
            title: x.title,
            toppingId: x.id,
          })),
        },
      ],
      removedItems: state?.removedItems?.filter((x) => x.tempId !== id),
    };
  }

  return state;
};

export default returnOrderItem;
